/* MERGE: seo_pdp_url — FULL FILE (new asset)
 * Saves collection context on product-card click (data-pdp-col) into sessionStorage.
 * Key: "pdp_col_context"
 */
(function () {
  if (window.__pdpColStore) return;
  window.__pdpColStore = true;

  var STORAGE_KEY = 'pdp_col_context';

  document.addEventListener(
    'click',
    function (e) {
      var link =
        e.target && e.target.closest
          ? e.target.closest('a[data-pdp-col][data-product-handle]')
          : null;
      if (!link) return;
      try {
        sessionStorage.setItem(
          STORAGE_KEY,
          JSON.stringify({
            handle: link.getAttribute('data-product-handle'),
            col: link.getAttribute('data-pdp-col'),
            colTitle: link.getAttribute('data-pdp-col-title') || '',
            ts: Date.now()
          })
        );
      } catch (err) {}
    },
    true
  );
})();
